/** 技术支持 FAQ：严格按《官网技术支持FAQ页面前端开发交接文档》原文，不得改写 */

export const SUPPORT_SEO = {
  title: "常见问题 | 智慧服务 - 焱图慧云",
  description:
    "焱图慧云常见问题，提供光伏踏勘、光伏巡检、智能清洗和风机巡检的公开问答与服务支持说明。",
  canonicalPath: "/technical-support/",
};

export const SUPPORT_CATEGORIES = [
  { key: "survey", label: "光伏踏勘" },
  { key: "inspection", label: "光伏巡检" },
  { key: "cleaning", label: "光伏清洗" },
  { key: "wind", label: "风机巡检" },
];

export const SUPPORT_ROUTES = [
  {
    key: "survey",
    title: "踏勘设计",
    desc: "光伏一点通",
    image:
      "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=520&q=80",
    alt: "光伏屋顶航拍",
  },
  {
    key: "inspection",
    title: "光伏无人机巡检",
    desc: "巡检、报告与消缺",
    image:
      "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?auto=format&fit=crop&w=520&q=80",
    alt: "光伏组件",
  },
  {
    key: "cleaning",
    title: "光伏智能清洗",
    desc: "机器人与无人机",
    image:
      "https://images.unsplash.com/photo-1494386346843-e12284507169?auto=format&fit=crop&w=520&q=80",
    alt: "光伏电站",
  },
  {
    key: "wind",
    title: "风机巡检",
    desc: "叶片巡检与分析",
    image:
      "https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&w=520&q=80",
    alt: "风电场",
  },
];

export const SUPPORT_PROCESS = [
  {
    index: "01",
    title: "查找常见问题",
    desc: "按产品线筛选页面中的公开问题。",
  },
  {
    index: "02",
    title: "提交项目基本资料",
    desc: "提供场景、规模和目标交付物，帮助确认适配性。",
  },
  {
    index: "03",
    title: "获得正式方案支持",
    desc: "由项目团队确认产品版本、服务范围和实施计划。",
  },
];

/** 16 条：踏勘 4、巡检 4、清洗 7、风机 1 */
export const SUPPORT_FAQS = [
  {
    category: "survey",
    tag: "踏勘设计",
    question: "是否有三维设计能力？",
    answer:
      "平台具备三维设计能力，标准版为适配大多数电站暂不开放，系统定制可支持三维设计。",
  },
  {
    category: "survey",
    tag: "踏勘设计",
    question: "能否进一步实现电气设计？",
    answer: "系统支持完整的电气设计功能，包括组串布线、逆变器匹配等。",
  },
  {
    category: "survey",
    tag: "踏勘设计",
    question: "踏勘产品是否有优惠？",
    answer: "具体优惠方案请参见会员活动页面，或联系我们的商务团队。",
  },
  {
    category: "survey",
    tag: "踏勘设计",
    question: "支持定制化需求吗？",
    answer: "支持。我们提供灵活的定制服务，欢迎进一步沟通您的具体需求。",
  },
  {
    category: "inspection",
    tag: "光伏巡检",
    question: "能否完全替代人工巡视？",
    answer:
      "对于螺丝松动、逆变器内部隐性问题无法完全替代，但对于接线盒虚焊、桥架线皮裸露等问题可精准识别。",
  },
  {
    category: "inspection",
    tag: "光伏巡检",
    question: "发现问题能提升多少发电量？",
    answer:
      "巡检系统提供精准的问题发现手段，配合消缺、清洗系统综合施策，可显著提升发电量。",
  },
  {
    category: "inspection",
    tag: "光伏巡检",
    question: "与竞品相比有何优势？",
    answer:
      "针对分布式和集中式电站提出差异化技术路线。分布式方案无需预先建模，简单完成巡检消缺；集中式方案实现7×24小时无人值守。",
  },
  {
    category: "inspection",
    tag: "光伏巡检",
    question: "系统如何报价？",
    answer: "提供私有化部署和功能定制，具体价格请与我们的商务团队联系。",
  },
  {
    category: "cleaning",
    tag: "光伏清洗",
    question: "适用哪些场景？",
    answer:
      "彩钢瓦、BIPV、铺设角度低于15°的电站、农光、渔光、山地电站等全场景适配。",
    product: "福宝清洗机器人",
  },
  {
    category: "cleaning",
    tag: "光伏清洗",
    question: "报价是多少？",
    answer:
      "遥控版套餐（二代13888元/三代16888元，含单刷头、双电池）；全自动版请与商务联系。",
    product: "福宝清洗机器人",
  },
  {
    category: "cleaning",
    tag: "光伏清洗",
    question: "交付周期多长？",
    answer: "遥控版1周内，自动版2-3周。",
    product: "福宝清洗机器人",
  },
  {
    category: "cleaning",
    tag: "光伏清洗",
    question: "相比人工清洗能省多少钱？",
    answer:
      "一次性投入替代全年人工清洗，成本降60%以上，提升发电量5%-15%，半年到一年回本。",
    product: "福宝清洗机器人",
  },
  {
    category: "cleaning",
    tag: "光伏清洗",
    question: "适用哪些场景？",
    answer: "除传统电站外，还可适配跟踪支架、柔性支架等复杂电站。",
    product: "光伏清洗无人机",
  },
  {
    category: "cleaning",
    tag: "光伏清洗",
    question: "报价是多少？",
    answer: "基础版108,000元，详细方案请进一步联系我们。",
    product: "光伏清洗无人机",
  },
  {
    category: "cleaning",
    tag: "光伏清洗",
    question: "交付周期多长？",
    answer: "2-3周。",
    product: "光伏清洗无人机",
  },
  {
    category: "wind",
    tag: "风机巡检",
    question: "系统如何报价？",
    answer:
      "电站级需求提供一体机方案，企业级定制需求提供私有化部署，具体请与商务联系。",
  },
];
